'use strict';
define(['angular'], function () {
    function Controller($scope, $rootScope, $state, form, $mdMedia, $mdDialog) {
        var vm = $scope;
        $mdDialog.cancel();
        vm.$state = $state;
        vm.$mdMedia = $mdMedia;
        vm.form = form;
        /* The form editor is a full screen: no left menu, a top bar to go back. */
        vm.isEditor = function () {
            return $state.includes('app.leadgeneration.form.form-generator');
        };
        /* The embed code is owned by the editor: it opens its own dialog. */
        vm.openEmbedCode = function (ev) {
            $rootScope.$broadcast('leadgeneration:openEmbedCode', ev);
        };

        /* Every section resolves data before showing: keep a skeleton on screen
           while the next view loads, so switching sections feels instant. */
        vm.sectionLoading = false;
        var onStateStart = $rootScope.$on('$stateChangeStart', function (event, toState) {
            var name = toState && toState.name || '';
            if (name.indexOf('app.leadgeneration.form') === 0 && name !== $state.current.name) {
                vm.sectionLoading = true;
            }
        });
        var onViewLoaded = $rootScope.$on('$viewContentLoaded', function () {
            vm.sectionLoading = false;
        });
        vm.$on('$destroy', function () {
            onStateStart();
            onViewLoaded();
        });
    }

    Controller.$inject = ['$scope', '$rootScope', '$state', 'form', '$mdMedia', '$mdDialog'];
    return Controller;
});
